<tui-badge class="badge badge_{{ color }} badge_size-{{ size }}" [size]="size" [iconStart]="icon">
  <span class="badge__text">
    {{ value }}
  </span>
</tui-badge>
